/** @jsx jsx */
import React, { Fragment, type PropsWithChildren } from 'react';
import { css, jsx, styled } from '@compiled/react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
// eslint-disable-next-line jira/import-whitelist
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { AppSkeletonImage } from '../../common/ui/AppSkeletonImage.tsx';
import imgSVGNavRefresh from './assets/roadmap-app-skeleton-nav-refresh.tpl.svg';
import imgSVG from './assets/roadmap-app-skeleton.tpl.svg';

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRightWidth: 0,
	},
});

export const RoadmapSkeleton = () => (
	<AppSkeletonImageContainer>
		{getWillShowNav4() ? (
			<AppSkeletonImage src={imgSVGNavRefresh} css={customCssStyles} />
		) : (
			<AppSkeletonImage src={imgSVG} css={customCssStyles} />
		)}
	</AppSkeletonImageContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Wrapper = styled.div({
	display: 'contents',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'>div > img, > div > object': {
		borderLeftWidth: '24px',
		borderRightWidth: '24px',
	},
});

const AppSkeletonImageContainer = componentWithCondition(
	() => isVisualRefreshEnabled(),
	({ children }: PropsWithChildren<{}>) => <Wrapper>{children}</Wrapper>,
	Fragment,
);
